import React, { useState } from "react";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CdmDestinationGroup } from "userful-chronos-app-common-js/dist/models/cdm/CdmGroup";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import DestinationGroupWidget from "../../../Widgets/DestinationGroup/DestinationGroupWidget";
import { useTranslation } from "react-i18next";
import { faMultiply, faTableCellsLarge } from "@fortawesome/pro-regular-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useMappingSelector } from "userful-chronos-common-store/dist/mapping";
import UserfulTooltip from "../../../Widgets/UserfulTooltip";

interface IProps {
    item: CdmDestinationGroup;
    itemID: StringID;
    onDelete?: Function;
    handleMouseEnter?: Function;
    handleMouseLeave?: Function;
}

export default function DestinationGroup(props: IProps) {
    const { t } = useTranslation();

    const videoWalls = useMappingSelector((state) => state.videowallsStore.videowallDestinations);
    const videos = useMappingSelector((state) => state.displaysStore.displayDestinations);
    const audios = [];

    const handleMouseEnter = () => {
        props.handleMouseEnter(true);
    };

    const handleMouseLeave = () => {
        props.handleMouseLeave(false);
    };
    return (
        <>
            <div className="header">
                <UserfulTooltip placement="bottom" title={props.item.name}>
                    <div className="cardLabel" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                        <FontAwesomeIcon icon={faTableCellsLarge} className="fontAwesomeCustomIcon" />
                        <div className="text">{props.item.name}</div>
                    </div>
                </UserfulTooltip>
                {props.onDelete && (
                    <div className="cardButtons">
                        <UserfulTooltip title={t("CommonUI.MappingGroups.removeDestination")}>
                            <div className="iconButton" onClick={() => props.onDelete()}>
                                <FontAwesomeIcon icon={faMultiply} className="fontAwesomeCustomIcon" />
                            </div>
                        </UserfulTooltip>
                    </div>
                )}
            </div>
            <div className="body">
                <div className="main">
                    <DestinationGroupWidget
                        group={props.item}
                        videoWalls={videoWalls}
                        videos={videos}
                        audios={audios}
                        defaultShow
                    />
                </div>
                {props.item.availability === "IN_USE" && (
                    <UserfulTooltip title={t("CommonUI.MappingGroups.inUse")}>
                        <FontAwesomeIcon icon={faTriangleExclamation} className="fontAwesomeCustomIcon" />
                    </UserfulTooltip>
                )}
            </div>
        </>
    );
}
